/** Capabilities belong to a view, not to a second implementation of its artwork. */
export interface FloorRenderFeatures {
    interactions: boolean
    minimap: boolean
    camera: boolean
    roofCutaway: boolean
    occluderFade: boolean
    grassSway: boolean
    nameplates: boolean
    healthBars: boolean
    levelLabels: boolean
    leaderHalo: boolean
}

export const ACTIVE_FLOOR_FEATURES: Readonly<FloorRenderFeatures> = Object.freeze({
    interactions: true, minimap: true, camera: true, roofCutaway: true,
    occluderFade: true, grassSway: true, nameplates: true, healthBars: true,
    levelLabels: true, leaderHalo: true,
})

export const OTHER_FLOOR_FEATURES: Readonly<FloorRenderFeatures> = Object.freeze({
    ...ACTIVE_FLOOR_FEATURES,
    interactions: false, minimap: false, camera: false, roofCutaway: false,
    occluderFade: false, levelLabels: false, leaderHalo: false,
})

// Another room seen from afar: its grass would be culled around a player who is not in it.
export const OBSERVATION_FEATURES: Readonly<FloorRenderFeatures> = Object.freeze({
    ...OTHER_FLOOR_FEATURES, roofCutaway: true, grassSway: false,
})
